<template>
    <div class="container-fluid mx-3 md:mx-10 my-8">
        <v-gantt-chart :startTime="startTime"
                       v-if="users.length > 0"
                       :endTime="endTime"
                       :dataKey="dataKey"
                       :cell-height="cellHeight"
                       :cell-width="10"
                       :scale="60"

                       customGenerateBlocks=""
                       :datas="mergeUserWithCalendar">
            <template
                v-slot:block="{data,getPositonOffset,getWidthAbout2Times,isInRenderingTimeRange,startTimeOfRenderArea,endTimeOfRenderArea}">
                <div class="gantt-block-item"
                     @mousemove="calculatePosition"
                     v-for="(item,index) in data.gtArray"
                     :key="item.id"
                     :style="{left:getPositonOffset(item.start)+'px',width:getWidthAbout2Times(item.start,item.end)+'px'}">
                    <div
                        class="flex w-full h-8 rounded-l-full rounded-r-full text-xs font-bold flex items-center px-1 text-white uppercase"
                        v-ripple
                        :class="`bg-${getColor(data, item.type)} ${isJobType(item.type) ? '' : 'border-2 border-gray-300 text-gray-700'}`">
                        <div class="flex items-stretch w-full justify-between">
                            <span class="flex items-center"
                                  v-for="c in calculateByWidth(getWidthAbout2Times(item.start,item.end))">
                                <span class="material-icons m-1"
                                      :style="{fontSize: `0.6rem`}">{{ getIcon(item.type)}}</span>
                            </span>
                        </div>
                    </div>
                    <Test :data="data" :item="item" :mouse-position="mousePosition"></Test>
                </div>
                <div v-if="data.gtArray.length === 0"
                     class="flex items-center h-full px-4 text-gray-400 text-xs uppercase">
                    Bez plánu
                </div>
            </template>
            <template v-slot:left="{data}">
                <TestLeft :data="data"></TestLeft>
            </template>
            <template v-slot:title>
                Časový prehľad
            </template>
        </v-gantt-chart>
        
        <md-speed-dial class="md-bottom-right">
            <md-speed-dial-target class="bg-orange-500" @click="() => eventCreation('event')">
                <md-icon class="md-morph-initial">add</md-icon>
                <md-icon class="md-morph-final">work</md-icon>
            </md-speed-dial-target>
            
            <md-speed-dial-content>
                <md-button class="md-icon-button" @click="() => eventCreation('lunch')">
                    <md-icon>fastfood</md-icon>
                </md-button>
                
                <md-button class="md-icon-button" @click="() => eventCreation('holiday')">
                    <md-icon>beach_access</md-icon>
                </md-button>
            </md-speed-dial-content>
        </md-speed-dial>
        
        <modal-window
            :modal-title="`Pridanie udalosti - ${getTitleByType}`"
            :on-close-click="() => this.showWindow = false"
            :full-height="true"
            :on-save-click="saveEvent"
            :show="showWindow">
            <multiselect v-model="selectedProject" :options="projectNames"
                         id="ajax" label="name" track-by="id"
                         v-if="windowType === 'event'"
                         :loading="isLoading"
                         :clear-on-select="false"
                         :options-limit="25"
                         @search-change="fetchProjects"
                         :searchable="true" :close-on-select="true" :show-labels="false"
                         placeholder="Vyberte jednu z možností"></multiselect>
            <md-field>
                <datetime
                    type="datetime"
                    v-model="fromDate"
                    :hour-step="1"
                    :minute-step="10"
                    placeholder="Od"
                    :format="dateFormat" :auto="true" input-class="md-input">
                    <template slot="button-cancel">
                        <md-button class="md-dense md-primary">
                            Zrušiť
                        </md-button>
                    </template>
                    <template slot="button-confirm">
                        <md-button class="md-dense md-primary">
                            OK
                        </md-button>
                    </template>
                </datetime>
            </md-field>
            <md-field>
                <datetime
                    type="datetime"
                    v-model="toDate"
                    :hour-step="1"
                    :minute-step="10"
                    placeholder="Od"
                    :format="dateFormat" :auto="true" input-class="md-input">
                    <template slot="button-cancel">
                        <md-button class="md-dense md-primary">
                            Zrušiť
                        </md-button>
                    </template>
                    <template slot="button-confirm">
                        <md-button class="md-dense md-primary">
                            OK
                        </md-button>
                    </template>
                </datetime>
            </md-field>
        </modal-window>
    </div>
</template>

<style lang="scss">
    .md-tooltip {
        @apply z-max;
    }
    
    .gantt-chart {
        @apply overflow-hidden;
    }
    
    .gantt-block-item {
        @apply flex items-center;
    }
    
    .gantt-leftbar, .gantt-leftbar-wrapper {
        @apply bg-gray-100;
    }
    
    .gantt-leftbar {
        @apply mt-1 pr-1;
    }
    
    .gantt-blocks-wrapper {
        @apply bg-white;
    }
    
    .gantt-timeline-block {
        border-left: 1px solid;
        @apply border-gray-100;
    }
    
    .vdatetime-popup__header,
    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span {
        @apply bg-orange-500;
    }
    
    .vdatetime-year-picker__item--selected,
    .vdatetime-time-picker__item--selected,
    .vdatetime-popup__actions__button {
        @apply text-orange-500;
    }
    
    .vdatetime-popup__actions__button {
        @apply p-0;
    }
    
    .vdatetime-popup__actions {
        @apply px-0 pb-3 pt-2;
    }
    .gantt-timeline-scale {
        display: none;
    }
</style>

<script>
    import {mapState} from "vuex";
    import Avatar from "../components/Avatar";
    import TestLeft from "./Calendar/TestLeft";
    import Test from "./Calendar/Test";
    import ModalWindow from "../components/Modal";

    export default {
        name: "Calendar",
        components: {ModalWindow, Avatar, TestLeft, Test},
        data: () => ({
            startTime: null,
            endTime: null,
            dataKey: "id",
            cellHeight: 3 * 16,
            mousePosition: 0,

            dateFormat: "dd.MM.yyyy HH:mm:ss",

            showWindow: false,
            windowType: 'event',
            fromDate: null,
            toDate: null,
            selectedProject: "",
            isLoading: false,
        }),

        computed: {
            ...mapState({
                users: state => state.users.all,
                calendar: state => state.calendar.events,
                projectNames: state => state.projects.all
            }),

            getTitleByType() {
                switch (this.windowType) {
                    case "event":
                        return 'Práca';
                    case "lunch":
                        return "Obed";
                    case "holiday":
                        return "Dovolenka";
                }
            },

            mergeUserWithCalendar() {
                let users = this.users;

                for (let user of users) {
                    user.gtArray = this.calendar.filter(event => {
                        return event.user_id === user.id
                    });
                }

                return users;
            },
        },

        beforeMount() {
            this.$store.dispatch("fetchUsers");
            this.$store.dispatch("fetchEvents");
            this.fetchProjects();
            this.startTime = moment().hours(7).format("YYYY-MM-DD hh:mm:ss");
            this.endTime = moment().add(6, 'days').format("YYYY-MM-DD hh:mm:ss");
        },

        methods: {
            fetchProjects(query = "") {
                this.isLoading = true;
                this.$store.dispatch("fetchProjects", {
                    search: query,
                    all: true
                }).then(() => {
                    this.isLoading = false
                })
            },
            
            // clicks
            eventCreation(type = 'event') {
                this.showWindow = true;
                this.windowType = type;
            },

            saveEvent() {
                let {fromDate, toDate, windowType, selectedProject} = this;
                fromDate = moment(this.fromDate).format("YYYY-MM-DD HH:mm:ss");
                toDate = moment(this.toDate).format("YYYY-MM-DD HH:mm:ss");

                let data = {project: selectedProject.id, fromDate, toDate, type: windowType === 'event' ? 'job' : windowType};

                this.$store.dispatch("saveEvent", data).then(() => {
                    this.$store.dispatch("fetchEvents").then(() => {
                        this.showWindow = false;
                        this.fromDate = null;
                        this.toDate = null;
                        this.users = this.$store.dispatch("fetchUsers"); // not correct but works ;)
                    });
                });
            },

            // calc and other
            calculateByWidth(width) {
                let ratio = width / 450;
                return Array(Math.ceil(ratio));
            },
            
            calculatePosition(e) {
                this.mousePosition = e.clientX;
            },

            isJobType(type) {
                return type === 'job';
            },

            getIcon(type) {
                switch (type) {
                    case 'lunch':
                        return 'fastfood';
                    case 'holiday':
                        return 'beach_access';
                    default:
                        return "work";
                }
            },

            getColor(data, type) {
                switch (type) {
                    case "job":
                        return data.color;
                    case 'lunch':
                    case 'holiday':
                        return 'gray-200';
                }
            }
        }
    }
</script>